module.exports = ".yeti-tab-menu-active {\n  font-weight: bold;\n  background-color: #ffffff; }\n\n.yeti-tab-menu-inactive {\n  font-weight: normal;\n  background-color: #f7f6f6; }\n\n.invalid {\n  color: red; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/reusable-components/tab-menu/tab-host.component.scss
// module id = 643
// module chunks = 0